import moment from "moment/moment";

export class TimeService {

  static GetInterval = (start, end, units = 'days') => moment(end).diff(moment(start), units)
  static FormatDate = (date) => moment(date);


}
